import React from 'react'
import LOGO from '../../assets/images/datagas-white.png'
import './index.css'


const PreLoaderTerpel = () => {
  return (
    <div style={{ width: '100%', backgroundColor: '#2A749B', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <img
        src={LOGO}
        style={{ alignSelf: 'center', maxWidth: '300px' }}
        className="heartbeat"
        alt="Logo Datagas"
      />
    </div>
  )
}
export default PreLoaderTerpel
